<template>
  <!--专题添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%;margin:20px auto; "
      >
        <el-row>
          <el-form-item label="选择作者" prop="publisherId">
            <el-select placeholder="请选择" v-model="toAdDas.publisherId">
              <el-option
                v-for="item in author"
                :key="item.id"
                :label="item.nickName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="专题名字" prop="specialName">
              <el-input placeholder="请输入内容" v-model="toAdDas.specialName" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="频道" prop="menuId">
              <el-select placeholder="请选择" v-model="toAdDas.menuId" clearable>
                <el-option
                  v-for="item in menuDas"
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="专题的说明" prop="specialExplain">
             
              <el-input
                type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="toAdDas.specialExplain"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="app专题封面图(650*330)" prop="imgUrl" ref="imgUrl">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="TopicUpt"
                :on-success="TopicSuccess"
                :before-upload="beforeUpload"
              >
                <img v-if="toAdDas.imgUrl" :src="toAdDas.imgUrl" class="avatar" />
               
                <i
                  :class="loadUpt ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                  style="marginTop:10px;font-size: 50px;"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="pc专题封面图(1200*470)" prop="pcImgUrl" ref="imgUrlPC">
              <el-upload
                class="avatar-uploader"
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="getTopicUptPc"
                :on-success="TopicSuccess"
                :before-upload="beforeUpload"
              >
                <img v-if="toAdDas.pcImgUrl" :src="toAdDas.pcImgUrl" class="avatar" />
               
                <i
                  :class="loadUptPC ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                  style="marginTop:10px;font-size: 50px;"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            v-if="menuPerm('special:add')"
          >保存</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.toAdDas.imgUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };

    var valiIconPC = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.toAdDas.pcImgUrl == "") {
        callback(new Error("pc专题封面图不能为空"));
      } else {
        callback();
      }
    };

    return {
      loadUpt: false, //加载
      loadUptPC: false, //pc加载
      menuDas: "", //频道的数据
      TopicUptImg: [], //app图片上传
      pcUptImg: [], //pc图片上传
      //添加的参数：
      toAdDas: {
        specialName: "", //专题名字
        imgUrl: "", //app专题封面图
        specialExplain: "", //专题的说明
        menuId: "", //展示的位置
        publisherId: "", //作者
        pcImgUrl: "" //pc专题封面图
      },
      toAdRule: {
        specialName: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        specialExplain: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        menuId: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        publisherId: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        imgUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        pcImgUrl: [{ required: true, validator: valiIconPC, trigger: "blur" }]
      },
      address: [
        {
          value: "1",
          label: "不显示"
        },
        {
          value: "2",
          label: "轮播"
        },
        {
          value: "3",
          label: "页面"
        }
      ],
      author: "" //作者
    };
  },
  methods: {
    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
           this.$message.error(res.message);
           this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise(resolve => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          img.src = e.target.result;
        };

        img.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            blob => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //图片上传：
    TopicUpt(file, fileList) {
      this.loadUpt = true; //加载
      this.TopicUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.TopicUptImg.push(resBase64);
        if (this.TopicUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.TopicUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toAdDas.imgUrl = res.content[0]; //接口url参数
              this.TopicUptImg = [];
              this.$refs.imgUrl.clearValidate();
              this.loadUpt = false; //加载
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
          
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    //pc图片上传：
    getTopicUptPc(file, fileList) {
      this.loadUptPC = true; //加载
      this.pcUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.pcUptImg.push(resBase64);
        if (this.pcUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.pcUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toAdDas.pcImgUrl = res.content[0]; //接口url参数
              this.pcUptImg = [];
              this.$refs.imgUrlPC.clearValidate();
              this.loadUptPC = false; //加载
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
          
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    TopicSuccess(res, file) {},
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/special/create", {
            specialName: this.toAdDas.specialName, //专题名字
            imgUrl: this.toAdDas.imgUrl, //app专题封面图
            pcImgUrl: this.toAdDas.pcImgUrl, //pc专题封面图
            specialExplain: this.toAdDas.specialExplain, //专题的说明
            menuId: this.toAdDas.menuId, //展示的位置
            authorId: this.toAdDas.publisherId //作者
          }).then(res => {
            if (res.success == true) {
              this.$router.push({ path: "/topic" });
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (
              !res.success && res.statusCode == "401"
            ) {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        } else {
          return false;
        }
      });
    },
    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then(res => {
        if (res.success == true) {
          this.menuDas = res.content;
          console.log(this.menuDas, " this.menuDas");
        }
        
        if (!res.success && res.statusCode == "401") {
           this.$message.error(res.message);
           this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    }
  },
  created() {
    this.getPosition(); //频道下拉框的数据
    this.getAuthor(); //作者
  }
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>